export const SPECIES_CATEGORY_RULES = {
  Ave: [
    { label:"Aves de 1 Dia", minAgeMonths:0, maxAgeMonths:1, ageLabel:"0 a 1 mês" },
    { label:"Aves Crescimento", minAgeMonths:1, maxAgeMonths:5, ageLabel:"1 a 5 meses" },
    { label:"Aves Corte", minAgeMonths:1, maxAgeMonths:4, ageLabel:"1 a 4 meses" },
    { label:"Aves Postura", minAgeMonths:5, maxAgeMonths:null, ageLabel:"5 meses ou mais" },
  ],
  Bovino: [
    { label:"Bezerros", minAgeMonths:0, maxAgeMonths:12, ageLabel:"0 a 12 meses" },
    { label:"Recria", minAgeMonths:13, maxAgeMonths:24, ageLabel:"13 a 24 meses" },
    { label:"Engorda", minAgeMonths:25, maxAgeMonths:36, ageLabel:"25 a 36 meses" },
    { label:"Marrucos", minAgeMonths:37, maxAgeMonths:null, sex:"Macho", ageLabel:"Machos com 37 meses ou mais" },
    { label:"Matrizes", minAgeMonths:37, maxAgeMonths:null, sex:"Fêmea", ageLabel:"Fêmeas com 37 meses ou mais" },
  ],
  Ovino: [
    { label:"Cordeiros", minAgeMonths:0, maxAgeMonths:12, ageLabel:"0 a 12 meses" },
    { label:"Crescimento", minAgeMonths:13, maxAgeMonths:24, ageLabel:"13 a 24 meses" },
    { label:"Matrizes", minAgeMonths:25, maxAgeMonths:null, sex:"Fêmea", ageLabel:"Fêmeas adultas" },
    { label:"Reprodutores", minAgeMonths:25, maxAgeMonths:null, sex:"Macho", ageLabel:"Machos adultos" },
  ],
  Equino: [
    { label:"Potros", minAgeMonths:0, maxAgeMonths:30, ageLabel:"0 a 30 meses" },
    { label:"Equinos Jovens", minAgeMonths:31, maxAgeMonths:60, ageLabel:"31 a 60 meses" },
    { label:"Equinos Adultos", minAgeMonths:61, maxAgeMonths:null, ageLabel:"61 meses ou mais" },
  ],
};

const normalize = (value="") => String(value || "").trim();

export function getAnimalCategoryOptions(species=""){
  return (SPECIES_CATEGORY_RULES[normalize(species)] || []).map(item => item.label);
}

export function getAnimalCategoryMeta(species="", category=""){
  return (SPECIES_CATEGORY_RULES[normalize(species)] || []).find(item => item.label === normalize(category)) || null;
}

export function getAnimalCategoryAgeLabel(species="", category=""){
  return getAnimalCategoryMeta(species, category)?.ageLabel || "";
}

export function resolveBovineCategoryByAgeMonths(ageMonths, sex="", purpose=""){
  const age = Number(ageMonths || 0);
  if(age <= 12) return "Bezerros";
  if(age <= 24) return "Recria";
  if(age <= 36) return "Engorda";
  const normalizedSex = normalize(sex);
  const normalizedPurpose = normalize(purpose).toLowerCase();
  if(normalizedSex === "Macho") return "Marrucos";
  if(normalizedPurpose.includes("matriz")) return "Matrizes";
  if(normalizedPurpose.includes("reprod")) return normalizedSex === "Fêmea" ? "Matrizes" : "Marrucos";
  if(normalizedSex === "Fêmea") return "Matrizes";
  return "Matrizes";
}

export function resolveEquineCategoryByAgeMonths(ageMonths){
  const age = Number(ageMonths || 0);
  if(age <= 30) return "Potros";
  if(age <= 60) return "Equinos Jovens";
  return "Equinos Adultos";
}
